import { IQuestionAnswers } from '@/services/types/faq/faqs';
import { IImage, IOdnMedia } from '@/services/types/search/rentals/id';
import { IBreadcrumb, ICoordinates } from '@/utility/commonDataTypes';

enum LocalityType {
  campground = 'campground',
}

enum PageType {
  locality = 'locality',
}

interface IAlternate {
  id: string;
  locale: string;
  title: string;
  url: string;
}

interface IBounds {
  ne: ICoordinates;
  sw: ICoordinates;
}

interface ILink {
  'locality-campground-directory': INearbyCampgroundsRaw[];
}

export interface INearbyCampgroundsRaw {
  id: string;
  listing_count?: number;
  parent_id: number;
  parent_title?: string;
  title?: string;
  url?: string;
}

interface INearbyCampgrounds {
  id: string;
  listing_count: number;
  parent_id: number;
  parent_title: string;
  title: string;
  url: string;
}

export const refineNearbyCampground = (cg: INearbyCampgroundsRaw): cg is INearbyCampgrounds => {
  if (cg.listing_count != null && !!cg.url && !!cg.title && !!cg.parent_title) return true;
  return false;
};

interface INearby {
  campground: INearbyCampgroundsRaw[];
  county: INearbyCampgroundsRaw[];
  locality: INearbyCampgroundsRaw[];
  park: INearbyCampgroundsRaw[];
  trail: INearbyCampgroundsRaw[];
}

interface ISection {
  content: string;
  image: string;
  title: string;
}

export interface IActivity {
  name: string;
}

export interface IAddress {
  city: string;
  country: string;
  postal_code: string;
  state: string;
  street: string;
}

export interface IAttr {
  name: string;
  value?: string;
}

export interface IAttribute {
  attr?: IAttr[];
  other?: IAttr[];
  supply?: IAttr[];
  hookup?: IAttr[];
}

interface IMedia {
  credits: string;
  description: string;
  subtitle: string;
  title: string;
  url: string;
}

export interface ISimpleImage {
  alt?: string;
  credits: string;
  description: string;
  subtitle: string;
  title: string;
  url: string;
  id?: string;
  width?: number;
  height?: number;
  odnMedia?: IOdnMedia;
}

interface IOrganization {
  name: string;
  url: string;
}

interface ICampgroundInfo {
  accessibility: string;
  activities: IActivity[];
  address: IAddress;
  attributes?: IAttribute;
  charges_cancellations: string;
  description: string;
  directions: string;
  email: string;
  facilities: string;
  map_url: string;
  media: IMedia[];
  natural_features: string;
  nearby_attractions: string;
  organization: IOrganization;
  other: string;
  phone: string;
  recreation: string;
  reservation_url: string;
}

interface IMeta {
  alternates: IAlternate[];
  bounds: IBounds;
  breadcrumbs: IBreadcrumb[];
  campground_info?: ICampgroundInfo;
  canonical_url: string;
  country_alpha: string;
  introduction: string;
  keywords: string[];
  links: ILink;
  listing_count: number;
  locale: string;
  locality_type: LocalityType;
  location: ICoordinates;
  nearby: INearby;
  pageType: PageType;
  region_code: string;
  questions?: string[];
  sections: ISection[];
  seo_description: string;
  seo_title: string;
  slug: string;
  title: string;
  url: string;
  url_path: string;
}

export interface ICampgroundProps {
  id: string;
  parent_id: string;
  metadata: IMeta;
  live: boolean;
  images: IImage[];
  error: IPageError;
  faqs: IQuestionAnswers[];
  rentalsListing: any[];
  fallback?: boolean;
}

export interface IPageError {
  statusCode: number;
  message?: string;
}
